// extracted by mini-css-extract-plugin
export var externalLink = "_br-0";
export var internalLinkLabel = "_br-1";